import React, { useState } from "react";
import { useMediaQuery } from "@mui/material";
import SoftBox from "../../components/SoftBox";
import SoftTypography from "../../components/SoftTypography";
import BadGuyCard from "./BadGuyCard";
import BadGuyMobileCard from "./BadGuyMobileCard";

import badGuyBg from "../../img/gamesettings/badguy-bg.png";
import badGuyBee from "../../img/gamesettings/badguy_futuristic-style-bee.png";
import badGuyWolfie from "../../img/gamesettings/badguy_ferocious-robotic-tiger.png";
import badGuyBear from "../../img/gamesettings/badguy_bear-blue-suit.png";
import badGuyYeti from "../../img/gamesettings/badguy_yeti_shades.jfif";

const BAD_GUYS = [
  {
    image: badGuyYeti,
    title: "The Yeti",
    labelSettings: { height: "130px" },
    full: true,
    info: {
      title: "The Yeti",
      description: "The Yeti, a towering figure cloaked in mystery and ice, prowls the frozen depths of the Gamemybiz realm"
    }
  },
  {
    image: badGuyBee,
    title: "The Mechanic Monstrosity",
    labelSettings: { height: "250px", slant: "75%" }
  },
  {
    image: badGuyWolfie,
    title: "The First Wolf",
    labelSettings: { height: "200px", slant: "73%" }
  },
  {
    image: badGuyBear,
    title: "The Bear",
    labelSettings: { height: "160px", slant: "67%" }
  }
];

const BadGuySelector = () => {
  const xxlBreak = useMediaQuery((theme) => theme.breakpoints.down("xxl"));
  const isMobileView = useMediaQuery("(max-width:767px)");
  const [selectedIndex, setSelectedIndex] = useState(0);

  if (isMobileView) {
    const selected = BAD_GUYS[selectedIndex];
    return (
      <SoftBox>
        <SoftBox
          sx={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "10px",
          }}
        >
          {BAD_GUYS.map(({ title, image }, index) => (
            <BadGuyMobileCard
              key={title}
              title={title}
              image={image}
              isLocked={index > 0}
              isSelected={index === selectedIndex}
              onSelect={() => setSelectedIndex(index)}
            />
          ))}
        </SoftBox>

        {/** Detail panel — plain surface card, updates with the tapped card */}
        <SoftBox
          sx={{
            marginTop: "12px",
            backgroundColor: "#FFF",
            border: "0.5px solid #D0D5DD",
            borderRadius: "12px",
            padding: "14px 16px",
          }}
        >
          <SoftTypography sx={{ fontFamily: "DM Sans", fontSize: "14px", fontWeight: 500, color: "#101828" }}>
            {selected.title}
          </SoftTypography>
          {selected.info?.description && (
            <SoftTypography
              sx={{
                fontFamily: "DM Sans",
                fontSize: "12.5px",
                fontWeight: 400,
                color: "#667085",
                lineHeight: 1.5,
                marginTop: "4px",
              }}
            >
              {selected.info.description}
            </SoftTypography>
          )}
        </SoftBox>
      </SoftBox>
    );
  }

  return (
    <SoftBox
      sx={{
        backgroundImage: `url(${badGuyBg})`,
        backgroundSize: "cover",
        backgroundPosition: "center center",
        minHeight: "576px",
        borderRadius: "8px",
        padding: "32px",
        display: "flex",
        justifyContent: "center",
        gap: "16px"
      }}
    >
      {BAD_GUYS.map(({ title, image, labelSettings, full, info }, index) => (
        <BadGuyCard
          key={title}
          title={title}
          image={image}
          verticalLabel={labelSettings}
          isLocked={index > 0}
          shouldReCenter={xxlBreak}
          {...full && ({ fullCover: full })}
          {...info && ({ info })}
        />
      ))}
    </SoftBox>
  );
}

export default BadGuySelector;
